<template>
  <div id="app">
    <b-navbar v-if="isLoggedIn && isServerAvailable" :style="styleObject" toggleable="md" type="dark" variant="dark" fixed="top">
      <b-button size="sm" v-b-toggle.sidebar-1 class="mr-3">
        <font-awesome-icon :icon="['fas', 'bars']" />
      </b-button>
      <b-navbar-brand v-b-toggle.sidebar-1>Рукавица</b-navbar-brand>

      <b-sidebar
        id="sidebar-1"
        title="Меню"
        shadow
        no-enforce-focus
        no-close-on-route-change
        v-model="isOpenMenu"
        width="240px"
      >
        <b-list-group id="menu" flush class="menu text-small">
          <b-list-group-item :to="{ path: '/home'}" :class="$route.name === 'Home' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="home" style="color: darkorange" class="mr-1"/>
            Личный кабинет
          </b-list-group-item>
          <b-list-group-item v-if="hasPermTask" :to="{ name: 'Tasks'}" :class="$route.name === 'Tasks' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="tasks" style="color: darkgreen" class="mr-1"/>
            {{ $t("message.tasks.title") }}
          </b-list-group-item>
          <b-list-group-item v-if="hasPermWorker" :to="{ path: '/workers'}" :class="$route.path === '/workers' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="people-carry" style="color: darkblue" class="mr-1"/>
            {{ $t("message.workers.title") }}
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCustomer" :to="{ path: '/customers'}" :class="$route.path === '/customers' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="user-tie" style="color: darkred" class="mr-1"/>
            {{ $t("message.customers.title") }}
          </b-list-group-item>
          <b-list-group-item v-if="hasPermLocation" :to="{ path: '/locations'}" :class="$route.path === '/locations' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="map-marked-alt" style="color: green" class="mr-1"/>
            {{ $t("message.locations.title") }}
          </b-list-group-item>
          <b-list-group-item v-if="hasPermOrganization" :to="{ path: '/organizations'}" :class="$route.path === '/organizations' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="building" style="color: darkred" class="mr-1"/>
            Организации
          </b-list-group-item>
        </b-list-group>

        <b-list-group v-if="hasPermStaff" flush class="menu text-small">
          <hr class="m-0">
          <b-list-group-item v-b-toggle:collapse-analytics :variant="navVariant">
            <font-awesome-icon icon="chart-line" style="color: darkorange" class="mr-1"/>
            Аналитика
            <span class="float-right when-open">
              <font-awesome-icon  icon="chevron-up" size="xs" />
            </span>
            <span class="float-right when-closed">
              <font-awesome-icon icon="chevron-right" size="xs" />
            </span>
          </b-list-group-item>

          <b-collapse id="collapse-analytics">
            <b-list-group-item v-if="hasPermStaff" :to="{ path: '/workers_analytics'}" :class="$route.path === '/workers_analytics' && 'active router-link-active'">
              <font-awesome-icon icon="chart-line" style="color: darkorange" class="mr-1"/>
              По исполнителям
            </b-list-group-item>
          </b-collapse>
        </b-list-group>

        <b-list-group v-if="hasPermStaff" flush class="menu text-small">
          <hr class="m-0">
          <b-list-group-item v-b-toggle:collapse-invoices :variant="navVariant">
            <font-awesome-icon icon="file-invoice-dollar" style="color: darkviolet" class="mr-1"/>
            Счета
            <span class="float-right when-open">
              <font-awesome-icon  icon="chevron-up" size="xs" />
            </span>
            <span class="float-right when-closed">
              <font-awesome-icon icon="chevron-right" size="xs" />
            </span>
          </b-list-group-item>

          <b-collapse id="collapse-invoices">
            <b-list-group-item v-if="hasPermStaff" :to="{ path: '/invoices'}" :class="$route.path === '/invoices' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="file-invoice-dollar" style="color: darkviolet" class="mr-1"/>
              Выставление счёта
            </b-list-group-item>
            <b-list-group-item v-if="hasPermStaff" :to="{ path: '/reconciliation_acts'}" :class="$route.path === '/reconciliation_acts' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="file-contract" style="color: darksalmon" class="mr-1"/>
              Акты сверки
            </b-list-group-item>
          </b-collapse>
        </b-list-group>

        <b-list-group v-if="hasPermRecruit" flush class="menu text-small">
          <hr class="m-0">
          <b-list-group-item v-b-toggle:collapse-recruit :variant="navVariant">
            <font-awesome-icon icon="people-arrows" style="color: royalblue" class="mr-1"/>
            Подбор
            <span class="float-right when-open">
              <font-awesome-icon  icon="chevron-up" size="xs" />
            </span>
            <span class="float-right when-closed">
              <font-awesome-icon icon="chevron-right" size="xs" />
            </span>
          </b-list-group-item>

          <b-collapse id="collapse-recruit">
            <b-list-group-item v-if="hasPermRecruitTask" :to="{ path: '/recruit_tasks'}" :class="$route.path === '/recruit_tasks' && 'active router-link-active'" :variant="navVariant">Заявки</b-list-group-item>
            <b-list-group-item v-if="hasPermRecruitJobPosting" :to="{ path: '/recruit_job_postings'}" :class="$route.path === '/recruit_job_postings' && 'active router-link-active'" :variant="navVariant">Объявления</b-list-group-item>
            <b-list-group-item v-if="hasPermLocationVacancy" :to="{ path: '/recruit_location_vacancies'}" :class="$route.path === '/recruit_location_vacancies' && 'active router-link-active'" :variant="navVariant">Шаблоны вакансий</b-list-group-item>
          </b-collapse>
        </b-list-group>

        <b-list-group v-if="hasPermStaff" flush class="menu text-small">
          <hr class="m-0">
          <b-list-group-item v-b-toggle:collapse-staff :variant="navVariant">
            <font-awesome-icon icon="id-card" style="color: black" class="mr-1"/>
            ЗУП
            <span class="float-right when-open">
              <font-awesome-icon  icon="chevron-up" size="xs" />
            </span>
            <span class="float-right when-closed">
              <font-awesome-icon icon="chevron-right" size="xs" />
            </span>
          </b-list-group-item>

          <b-collapse id="collapse-staff">
            <b-list-group-item v-if="hasPermStaff" :to="{ path: '/staffs'}" :class="$route.path === '/staffs' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="id-card" style="color: black" class="mr-1"/>
              Персонал
            </b-list-group-item>
            <b-list-group-item v-if="hasPermStaff" :to="{ path: '/accruals'}" :class="$route.path === '/accruals' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="cash-register" style="color: darkslateblue" class="mr-1"/>
              Начисления зарплаты
            </b-list-group-item>
            <b-list-group-item v-if="hasPermStaff" :to="{ path: '/salaries'}" :class="$route.path === '/salaries' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="cash-register" style="color: darkslateblue" class="mr-1"/>
              Выплаты зарплаты
            </b-list-group-item>
            <b-list-group-item v-if="hasPermStaff" :to="{ path: '/salary_summary'}" :class="$route.path === '/salary_summary' && 'active router-link-active'" :variant="navVariant">
              <font-awesome-icon icon="cash-register" style="color: darkslateblue" class="mr-1"/>
              Зарплатная ведомость
            </b-list-group-item>
          </b-collapse>
        </b-list-group>

        <b-list-group flush class="menu text-small">
          <hr class="m-0">
          <b-list-group-item v-if="hasPermUser" :to="{ path: '/users'}" :class="$route.path === '/users' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="users" class="mr-1"/>
            Пользователи
          </b-list-group-item>

          <b-list-group-item v-if="hasPermRole" :to="{ path: '/user_roles'}" :class="$route.path === '/user_roles' && 'active router-link-active'" :variant="navVariant">
            <font-awesome-icon icon="user-cog" class="mr-1"/>
            Роли
          </b-list-group-item>

          <b-list-group-item v-if="hasPermCatalog" :to="{ path: '/catalogs'}" :class="$route.path === '/catalogs' && 'active router-link-active'">
            <font-awesome-icon icon="list" style="color: black" class="mr-1"/>
            Справочники
          </b-list-group-item>
        </b-list-group>
      </b-sidebar>

      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template #button-content>
            <em>{{user.name}}</em>
          </template>
          <b-dropdown-item @click="logout">{{ $t("message.login.logout") }}</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>

    <div v-else-if="!isLoggedIn && !isServerAvailable">
      <router-view/>
    </div>

    <div class="navbar-height" :style="styleObject">
      <router-view/>
    </div>

    <ErrorsModalWindow :offline="noConnectionError" :not-found="notFoundError" :forbidden="forbiddenError" v-model="showErrorModal"/>

    <portal-target name="app"/>
  </div>
</template>

<script>
import ErrorsModalWindow from './components/Alerts/ErrorsModalWindow.vue'
import permissions from "./utilites/permissions";
import {PERM} from "./utilites/permissions";
import { EventBus } from './utilites/eventBus'

export default {
  name: 'App',
  components: { ErrorsModalWindow },
  mixins: [permissions],
  data () {
    return {
      user: "",
      navVariant: "",
      isOpenMenu: true,
      styleObject: {
        marginLeft: '0px',
      },
      isServerAvailable: true,
      noConnectionError: false,
      notFoundError: false,
      forbiddenError: false,
      showErrorModal: false,
      check: null,
    }
  },
  created() {
    this.configureView();
    window.addEventListener('online', this.checkServerStatus);
    window.addEventListener('offline', this.checkServerStatus);

    EventBus.$on('http-error-404', () => {
      this.forbiddenError = false;
      this.noConnectionError = false;
      this.notFoundError = true;
      this.showErrorModal = true;
    });

    EventBus.$on('http-error-403', () => {
      this.notFoundError = false;
      this.noConnectionError = false;
      this.forbiddenError = true;
      this.showErrorModal = true;
    });
  },
  mounted() {
    if (this.isLoggedIn && this.$route.name !== 'Login') {
      this.userInfo();
    }

    this.checkServerStatus();
    this.check = setInterval(() => {
      this.checkServerStatus();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.check);
    window.removeEventListener('online', this.checkServerStatus);
    window.removeEventListener('offline', this.checkServerStatus);
    EventBus.$off('http-error-404');
    EventBus.$off('http-error-403');
  },
  methods: {
    checkServerStatus() {
      const isOnline = window.navigator.onLine

      if (!isOnline) {
        this.isServerAvailable = false;
        this.noConnectionError = true;
        this.showErrorModal = true;
        return;
      }

      this.$http.get("ping").then( result => {
        if (result.status === 200) {
          this.isServerAvailable = true;
          this.noConnectionError = false;
          this.showErrorModal = false;
        }
      }, error => {
        this.isServerAvailable = false;
        this.noConnectionError = true;
        this.showErrorModal = true;
      });
    },
    configureView() {
      let style = {
        marginLeft: '0px',
        transition: 'margin 300ms ease-in-out'
      };
      if (this.isOpenMenu) {
        style = {
          marginLeft: '240px',
          transition: 'margin 300ms ease-in-out'
        };
      }
      this.styleObject = style;
    },
    logout() {
      this.$store.dispatch("logout").then(res => {
        this.user= "";
        this.$router.push('/login').catch(()=>{});
      })
    },
    userInfo() {
      this.$http.get("users/info").then(result => {
        if (result.status === 200) {
          this.user = result.body;
          this.$store.dispatch("updatePermissions", {
            role: result.body.role,
            permissions: result.body.permissions,
          }).then();
        }
      }, error => {
        console.log(error);
      });
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    hasPermCatalog() {
      return this.hasPermission([PERM.CATALOG])
    },
    hasPermWorker() {
      return this.hasPermission([PERM.WORKER])
    },
    hasPermTask() {
      return this.hasPermission([PERM.TASK])
    },
    hasPermCustomer() {
      return this.hasPermission([PERM.CUSTOMER])
    },
    hasPermLocation() {
      return this.hasPermission([PERM.LOCATION])
    },
    hasPermLocationVacancy() {
      return this.hasPermission([PERM.LOCATION_VACANCY])
    },
    hasPermOrganization() {
      return this.hasPermission([PERM.ORGANIZATION])
    },
    hasPermRecruit() {
      return this.hasPermission([PERM.RECRUIT])
    },
    hasPermRecruitTask() {
      return this.hasPermission([PERM.RECRUIT_TASK])
    },
    hasPermRecruitJobPosting() {
      return this.hasPermission([PERM.RECRUIT_JOB_POSTING])
    },
    hasPermUser() {
      return this.hasPermission([PERM.USER])
    },
    hasPermRole() {
      return this.hasPermission([PERM.ROLE])
    },
    hasPermStaff() {
      return this.hasPermission([PERM.STAFF])
    },
  },
  watch: {
    "isOpenMenu": {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.configureView();
        }
      },
      deep: true
    },
    isLoggedIn: {
      handler: function (newVal) {
        if (newVal) {
          this.userInfo();
        } else {
          this.user = "";
        }
        this.isOpenMenu = newVal !== undefined ? newVal : true;
      }
    },
    '$route'() {
      this.showErrorModal = false;
    },
  }
}
</script>

<style>

/* ZIndex */
.topZIndex{
  z-index: 1050;
}

/* Text */
.text-small {
  font-size: smaller;
}

/* Collapsed */
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

/* Menu */
.menu .list-group-item {
  border: none;
}

/* NavBar */
@media (max-width: 575.98px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/*// Small devices (landscape phones, 576px and up)*/
@media (min-width: 576px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/*// Medium devices (tablets, 768px and up)*/
@media (min-width: 768px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/*// Large devices (desktops, 992px and up)*/
@media (min-width: 992px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/*// X-Large devices (large desktops, 1200px and up)*/
@media (min-width: 1200px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/*// XX-Large devices (larger desktops, 1400px and up)*/
@media (min-width: 1400px) {
  .navbar-height {
    margin-top: 56px;
  }
}

/* Vertical divider */
.vr {
  border:         none;
  border-left:    1px solid hsla(200, 10%, 50%,100);
  height:         50%;
  width:          1px;
}

/* Pagination */
#pagination ul {
  margin-bottom: 0;
}

#pagination {
  margin-bottom: 0;
}

.pagination {
  margin-bottom: 0 !important;
}

/* Table */
.table-centered td {
  text-align: center;
  vertical-align: middle;
}

.table-centered th {
  text-align: center;
  vertical-align: middle;
}

.pointer-cell {
  cursor: pointer;
}

/* Table Sticky */
.b-table-sticky-header > .table.b-table > thead > tr > th {
  position: sticky !important;
  border-top: 0;
}

.b-table-sticky-header {
  max-height: calc(100vh - 218.8px) !important;
  min-height: 300px;
}

.b-table-sticky-header > .table.b-table > tfoot > tr > th {
  position: sticky !important;
  bottom: 0;
  border-bottom: 0;
}


/* Content Sticky Header */
#header {
  top: 56px;
  position: sticky;
  z-index: 1020;
}

/* Content Sticky Footer */
#footer {
  position: sticky;
  bottom: 0;
}

/* Content Sticky Filters */
#filters {
  position: sticky;
  top: 87px;
  z-index: 5;
  background-color: white;
}

/* Model Content Padding */
.modal-body-select {
  padding: 0 !important
}

/* Model Content Sticky */
.modal-sticky {
  max-height: calc(100vh - 300.8px) !important;
}

/* Model Content Sticky Filters */
#modal-filters {
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: white;
}

/* Autocomplete Select Input */
.autocomplete-input {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 2000;
}

/* Autocomplete Select Input Group Item */
.autocomplete-input .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue